import React, { Fragment, useState } from 'react'

function DatosGeneralesComponent(props) {

    let { domiciliofiscalcliente } = props.data

    let filtrodomicilio = domiciliofiscalcliente?.filter(domicilio => domicilio?.isbaja == false && domicilio?.domicilioprincipal == true)
    let cadenaDomicilio = ''
    const arrayDomicilio = []
    if (filtrodomicilio?.[0]?.calle === 'Otro') arrayDomicilio.push(filtrodomicilio?.[0]?.otracalle)
    else arrayDomicilio.push(filtrodomicilio?.[0]?.calle)
    if (filtrodomicilio?.[0]?.numerointerior != null && filtrodomicilio?.[0]?.numerointerior != '') arrayDomicilio.push(filtrodomicilio?.[0]?.numerointerior)
    else arrayDomicilio.push('S/N')
    if (filtrodomicilio?.[0]?.numeroexterior != null && filtrodomicilio?.[0]?.numeroexterior != '') arrayDomicilio.push(filtrodomicilio?.[0]?.numeroexterior)
    else arrayDomicilio.push('S/N')

    if (filtrodomicilio?.[0]?.colonia != null && filtrodomicilio?.[0]?.colonia != '') arrayDomicilio.push(filtrodomicilio?.[0]?.colonia)
    if (filtrodomicilio?.[0]?.localidad != null && filtrodomicilio?.[0]?.localidad != '') arrayDomicilio.push(filtrodomicilio?.[0]?.localidad)
    if (filtrodomicilio?.[0]?.municipioalcaldia != null && filtrodomicilio?.[0]?.municipioalcaldia != '') arrayDomicilio.push(filtrodomicilio?.[0]?.municipioalcaldia)
    if (filtrodomicilio?.[0]?.estado != null && filtrodomicilio?.[0]?.estado != '') arrayDomicilio.push(filtrodomicilio?.[0]?.estado)
    if (filtrodomicilio?.[0]?.codigopostal != null && filtrodomicilio?.[0]?.codigopostal != '') arrayDomicilio.push(filtrodomicilio?.[0]?.codigopostal)
    for (const i in arrayDomicilio) {
        if (Number(i) === 0) {
            cadenaDomicilio += arrayDomicilio[i]
        } else if (Number(i) + Number(1) === arrayDomicilio.length) {
            cadenaDomicilio += ', ' + arrayDomicilio[i]
        } else {
            cadenaDomicilio += ', ' + arrayDomicilio[i]
        }
    }
    const obtenerCadenaActividades = (actividadcliente) => {
        const arregloCadena = actividadcliente?.map(item => item?.tipoactividad?.actividad || '');
        let combinacionCadena = '';
        if (arregloCadena.length == 1) {
            combinacionCadena = arregloCadena[0];
        } else if (arregloCadena.length > 1) {
            combinacionCadena = arregloCadena.slice(0, -1).join(', ') + ' y ' + arregloCadena.slice(-1);
        }
        return combinacionCadena;
    };


    return (
        <Fragment>
            <div className='row mt-5 pt-3' style={{ margin: 0, padding: 0, marginRight: '10%' }}>
                <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Número de socio: <br /> </b> {props?.data?.numerosocio} </label> </div>
                <div className="col-md-8 mt-3 ps-5 text-start"><label><b>Razón social: <br /> </b> {props?.data?.nombrerazonsocial} </label> </div>
                <div className="col-md-4 mt-3 ps-5 text-start"><label><b>RFC: <br /> </b> {props?.data?.rfc} </label> </div>
                <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Teléfono: <br /> </b> {props?.data?.telefono} </label> </div>
                <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Correo electrónico: <br /> </b> {props?.data?.correoelectronico} </label> </div>
                <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Nombre representante legal: <br /> </b> {props?.data?.nombrerepresentantelegal == '' ? '---' : props?.data?.nombrerepresentantelegal} </label> </div>
                <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Teléfono representante: <br /> </b> {props?.data?.telefonorepresentante == '' ? '---' : props?.data?.telefonorepresentante} </label> </div>
                <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Correo representante: <br /> </b> {props?.data?.correoelectronicorepresentante == '' ? '---' : props?.data?.correoelectronicorepresentante} </label> </div>
                <div className="col-md-12 mt-3 ps-5 text-start"><label><b>Domicilio Fiscal: <br /> </b> {cadenaDomicilio?.toUpperCase()} </label> </div>
                <div className="col-md-12 mt-3 ps-5 text-start"><label><b>Cadena productiva: <br /> </b> {obtenerCadenaActividades(props?.data?.actividadcliente)?.toUpperCase()} </label> </div>
            </div>
        </Fragment>
    )
}

export default DatosGeneralesComponent